import { oz } from '@weft/utils';

export const SYNC_ENTITIES = Object.freeze({
  customer: 'Customer',
  invoice: 'Invoice',
});

export const SyncEntitySchema = oz.nativeEnum(SYNC_ENTITIES);

export type SyncEntity = oz.infer<typeof SyncEntitySchema>;